import API from '../services/api';

let instance = null;
const api = new API();

export const EXPORT_ALL_URL = 'api/attribution/postbacks';

export default class PartnerConfigService {
    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    exportAll(partnerId = null) {
        return api.getFile(EXPORT_ALL_URL, {
            method: 'POST',
            credentials: 'include',
            responseType: 'blob',
            body: {
                partner_id: partnerId,
            },
        });
    }
}
